export const enum UniversalFilterDateIsOnOrAfterModeOptions {
  EXACT_DAY = 'exact_day',
  TODAY = 'today',
  TOMORROW = 'tomorrow',
  YESTERDAY = 'yesterday',
  ONE_WEEK_AGO = 'one_week_ago',
  ONE_WEEK_FROM_NOW = 'one_week_from_now',
  ONE_MONTH_AGO = 'one_month_ago',
  ONE_MONTH_FROM_NOW = 'one_month_from_now',
  NUMBER_OF_DAYS_AGO = 'number_of_days_ago',
  NUMBER_OF_DAYS_FROM_NOW = 'number_of_days_from_now'
}
